export default __webpack_public_path__ + "static/media/fb_logo_round.7fce0fac.png";